import { bothDirectionsSortOptions, sortOptions } from '../constants';
import type { DropdownOption } from '../types';
import type { TranslateFunc } from 'src/components/translate';
import type { SortInfo } from 'src/types';

export const getDropdownSortOptions = (
  sort: SortInfo | undefined | null,
  t: TranslateFunc
) => {
  const bothDirectionsOptions = bothDirectionsSortOptions
    .filter(x => sort?.available?.includes(x))
    .reduce<DropdownOption[]>(
      (arr, option) => [
        {
          name: t('common', `sort.${option}:asc`),
          value: `${option}:asc`,
        },
        {
          name: t('common', `sort.${option}:desc`),
          value: `${option}:desc`,
        },
        ...arr,
      ],
      []
    )
    .filter(x => x.value !== `${sort?.name}:${sort?.direction}`);

  return sortOptions
    .filter(x => sort?.available?.includes(x))
    .filter(
      x => x !== sort?.name && !bothDirectionsSortOptions.includes(x as any)
    )
    .map(option => ({
      name: t('common', `sort.${option}`),
      value: `${option}`,
    }))
    .concat(bothDirectionsOptions);
};
